<it-footer>
  <ng-container header>
    <div class="it-brand-wrapper">
      <a href="projects" data-focus-mouse="false" aria-disabled="true">
        <it-icon name="code-circle" />
        <div class="it-brand-text">
          <p class="h2">{{ institutionName() | translate }}</p>
          <p class="h3 d-none d-md-block">{{ tagLine() ?? '' | translate }}</p>
        </div>
      </a>
    </div>
  </ng-container>
  <ng-container links>
    <div class="row">
      @for (section of sections(); track section.title; let last = $last) {
        <div class="col-lg-3 col-md-3 col-sm-6" [class.pb-2]="!last">
          <h4>
            <a
              href="projects"
              aria-disabled="true"
              [title]="('FOOTER.GO_TO_PAGE: ' | translate) + (section.title | translate)"
              >{{ section.title | translate }}</a
            >
          </h4>
          <it-list linkList="true">
            @for (link of section.links; track link.text) {
              <it-list-item [href]="link.url">{{ link.text | translate }}</it-list-item>
            }
          </it-list>
        </div>
      }
    </div>
  </ng-container>

  <ng-container contacts>
    <div class="row">
      <div class="col-lg-4 col-md-4 pb-2">
        <h4>Contatti</h4>
        <article class="d-flex flex-column gap-1">
          <strong>{{ contacts.name | translate }}</strong>
          <span>{{ contacts.address | translate }}</span>
          <span>{{ 'FOOTER.CONTACTS.PHONE' | translate }}: {{ contacts.phone | translate }}</span>
          <span>
            {{ 'FOOTER.CONTACTS.PEC' | translate }}:
            <a [href]="'mailto:' + contacts.pec"> {{ contacts.pec }}</a>
          </span>
          <span>
            {{ 'FOOTER.CONTACTS.TAX_CODE_VAT_NUMBER' | translate }}: {{ contacts.fiscalCode }}
          </span>
          <span>
            {{ 'FOOTER.CONTACTS.EMAIL' | translate }}:
            <a [href]="'mailto:' + contacts.email"> {{ contacts.email }}</a>
          </span>
        </article>
      </div>

      <div class="col-lg-4 col-md-4 pb-2"></div>

      <div class="col-lg-4 col-md-4 pb-2">
        <drw-socials position="footer"></drw-socials>
      </div>
    </div>
  </ng-container>

  <ng-container small-links>
    <ul>
      @for (link of extraLinks(); track link.label) {
        <li class="list-inline-item">
          <a [href]="link.url"
            >{{ link.label | translate }}
            @if (link.screenLabel) {
              <span class="visually-hidden">{{ link.screenLabel | translate }}</span>
            }
          </a>
        </li>
      }
    </ul>
  </ng-container>
</it-footer>
